import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/core/core.routing').then(({ CORE_ROUTES }) => CORE_ROUTES),
  },
];
